import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { AppConfirmService } from '../core/app-confirm.service';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ButtonModule, CommonModule, DialogModule],
  template: `
    <p-dialog
      [visible]="visible()"
      (visibleChange)="handleVisibleChange($event)"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [dismissableMask]="true"
      [style]="{ width: 'min(440px, calc(100vw - 32px))' }"
      styleClass="app-confirm-dialog"
    >
      <ng-template pTemplate="header">
        @if (confirmation(); as request) {
          <span>{{ request.title }}</span>
        }
      </ng-template>

      @if (confirmation(); as request) {
        <div class="confirm-body">
          <span class="confirm-icon" [class.danger]="request.tone === 'danger'" [class.warning]="request.tone === 'warning'">
            <i [class]="request.tone === 'danger' ? 'pi pi-exclamation-triangle' : 'pi pi-question-circle'"></i>
          </span>
          <p>{{ request.message }}</p>
        </div>
      }

      <ng-template pTemplate="footer">
        @if (confirmation(); as request) {
          <button pButton type="button" [label]="request.cancelLabel" severity="secondary" outlined (click)="confirm.cancel()"></button>
          <button
            pButton
            type="button"
            [label]="request.confirmLabel"
            [severity]="request.tone === 'danger' ? 'danger' : 'primary'"
            (click)="confirm.accept()"
          ></button>
        }
      </ng-template>
    </p-dialog>
  `,
  styles: [`
    .confirm-body {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      padding-top: 4px;
    }

    .confirm-body p {
      margin: 0;
      color: var(--cc-text);
      font-size: var(--cc-text-base);
      line-height: var(--cc-leading-relaxed);
    }

    .confirm-icon {
      width: 38px;
      height: 38px;
      display: grid;
      place-items: center;
      flex: 0 0 auto;
      border-radius: 50%;
      color: #0369a1;
      background: var(--cc-blue-soft);
      font-size: 1.05rem;
    }

    .confirm-icon.danger {
      color: var(--cc-red);
      background: var(--cc-red-soft);
    }

    .confirm-icon.warning {
      color: #a16207;
      background: var(--cc-amber-soft);
    }
  `]
})
export class AppConfirmDialogComponent {
  readonly confirm = inject(AppConfirmService);
  readonly confirmation = this.confirm.request;
  readonly visible = computed(() => !!this.confirmation());

  handleVisibleChange(visible: boolean): void {
    if (!visible) {
      this.confirm.cancel();
    }
  }
}
